import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const SeeMorePublicationItemSkeleton: FC = () => (
  <div className="row">
    <div className="card col-12 mb-4">
      <div className="row">
        <div className="card-header col col-md-4 bg-lvl2" />
        <div className="card-body col col-md-8 ps-md-4 pb-0">
          <h5>
            <Skeleton width="8em" />
          </h5>
          <a className="text-primary">
            <h3>
              <Skeleton />
            </h3>
          </a>
          <span className="text-secondary">
            <Skeleton width="12em" />
          </span>
        </div>
      </div>
    </div>
  </div>
);
